<template>
  <v-card outlined class="card-center">
    <v-container class="px-1 py-1" fluid>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-card outlined>
          <v-card-title class="pt-2 pb-0">
            {{ $t('ELE0028') }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <PartCodeInput v-if="isEpson" v-model="searchCondition.partCd" />
                <SupplierPartInput v-else v-model="searchCondition.partCd" :supplierCd="''" isSearchByLoginCompany />
              </v-col>
              <v-col cols="4">
                <ManufacturerInput v-model="searchCondition.manufacturerCd" />
              </v-col>
              <!-- <v-col cols="2">
                <OqcIqcInput v-model="searchCondition.inspTimingCd" required />
              </v-col> -->
              <v-col cols="2">
                <InspTimingDtlInput
                  v-model="searchCondition.inspTimingDtlCd"
                  :inspTimingCd="inspTimingCdForDtl"
                  :inspClassCd="inspClassCd"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <TextFieldInputWithDatePicker :label="$t('ELE0266')" v-model="searchCondition.endDateFrom" />
              </v-col>
              <span class="px-4 py-2 mt-3"> {{ $t('ELE0141') }} </span>
              <v-col cols="2">
                <TextFieldInputWithDatePicker :label="$t('ELE0266')" v-model="searchCondition.endDateTo" />
              </v-col>
              <v-spacer />
              <span class="d-flex flex-row space-between mr-4">
                <BtnSearch class="mt-2" @click="onClickSearch" :disabled="invalid ? true : isRequired" />
              </span>
            </v-row>
          </v-card-text>
        </v-card>
      </ValidationObserver>
    </v-container>
    <v-divider />
    <v-container fluid v-if="chartDataExists">
      <v-row>
        <v-col cols="2">
          <TextFieldRef :label="$t('ELE0175')" :value="defectItems.inspQty" right />
        </v-col>
        <v-col cols="2">
          <TextFieldRef :label="$t('ELE0264')" :value="defectItems.okQty" right />
        </v-col>
        <v-col cols="2">
          <TextFieldRef :label="$t('ELE0265')" :value="defectItems.ngQty" right />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-container fluid>
            <DefectParetoChart :items="defectItems.defectList" />
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import moment from 'moment'
import { ValidationObserver } from 'vee-validate'
import { OqcIqcCd, InspClassCd } from '@/enum.js'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import DefectParetoChart from '@/components/organisms/report/chart/DefectParetoChart'
import PartCodeInput from '@/components/atoms/select/PartCodeInput'
import ManufacturerInput from '@/components/atoms/select/ManufacturerInput'
import OqcIqcInput from '@/components/atoms/select/OqcIqcInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import SupplierPartInput from '@/components/atoms/select/SupplierPartInput'
import InspTimingDtlInput from '@/components/atoms/select/InspTimingDtlInput'

export default {
  name: 'DefectParetoChartForm',

  mixins: [APIUtils, Message, Loading],

  components: {
    ValidationObserver,
    TextFieldInput,
    TextFieldRef,
    BtnSearch,
    DefectParetoChart,
    PartCodeInput,
    ManufacturerInput,
    OqcIqcInput,
    TextFieldInputWithDatePicker,
    SupplierPartInput,
    InspTimingDtlInput,
  },

  data() {
    return {
      chartDataExists: false,
      defectItems: [],
      inspTimingCdForDtl: this.$store.getters.canOQCOnly ? OqcIqcCd.OQC : '',
      inspClassCd: InspClassCd.APP,
      searchCondition: {
        partCd: '',
        manufacturerCd: '',
        inspTimingDtlCd: '',
        endDateFrom: moment().subtract(1, 'd').format('YYYY-MM-DD'),
        endDateTo: moment().format('YYYY-MM-DD'),
      },
    }
  },

  computed: {
    isRequired: {
      get() {
        let result = true
        if (this.searchCondition.partCd != '' || this.searchCondition.manufacturerCd != '') {
          result = false
        } else {
          result = true
        }
        return result
      },
    },
    isEpson: {
      get() {
        let result = false
        if (this.$store.getters.isEpson) {
          result = true
        }
        return result
      },
    },
  },

  methods: {
    async onClickSearch() {
      this.chartDataExists = false
      this.startLoading()
      try {
        if (moment(this.searchCondition.endDateFrom).add(1, 'y') <= moment(this.searchCondition.endDateTo)) {
          this.setErrorMessage(this.$t('MSG0085'))
          return
        }
        const params = {
          partCd: this.searchCondition.partCd,
          manufacturerCd: this.searchCondition.manufacturerCd,
          inspTimingDtlCd: this.searchCondition.inspTimingDtlCd,
          endDateFrom: this.searchCondition.endDateFrom,
          endDateTo: this.searchCondition.endDateTo,
        }
        this.defectItems = await API.get('/inspApp/defectPareto', params)
        this.chartDataExists = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0185') })))
      } finally {
        this.stopLoading()
      }
    },
  },
}
</script>
